import Page from "../../../../modules/Core/Components/Page";
import templateDefault from "../../../templates/default/pages/user/addresses";

export default class Addresses extends Page {
  template = templateDefault;
  fullAuth = true;

  onAuth(data) {
    const { auth } = data;
    if (!auth.isAuthenticated()) {
      this.redirectTo("/");
    }
  }

  onLoad(data) {
    super.onLoad(data);

    this.getApp().updateWindowTitle(
      `${this.ucfirst("addresses-title")} | ${this.trans("window-title")}`
    );
    this.scrollToTop();
  }
}
